

const Copyright = () => {
    const currentYear = new Date().getFullYear();
  return <>Copyright {currentYear}, Storbolt, All Rights Reserved.</>;
};

export default Copyright;
